export class OfferedRateModel {
    Id: number;

    TotalNumberOfUnits: number;

    TotalLandMeter: number;

    TotalCubicMeter: number;

    FreightRateValidity: Date;

    FreightRate: number;

    RateBasisFreightRate: number;

    BAF: number;

    RateBasisBAF: number;

    CAF: number;

    RateBasisCAF: number;

    THC: number;

    RateBasisTHC: number;

    OtherCharges: number;

    RateBasisOtherChareges: number;

    TotalFreightCost: number;

    CostPerUnit: number;

    CostPerCubicMeter: number;

    ConsignmentId: number;

    IsDeleted: boolean;

    RateRequestId: number;

    ratetotal: number;

    Baftotal: number;

    Caftotal: number;

    Thctotal: number;

    Otherchargestotal: number;

    CreatedBy: number;
    Disclaimer: string;
}